document.addEventListener('DOMContentLoaded', function () {
  const downloadPDFElements = document.querySelectorAll('.download-pdf');
  Array.from(downloadPDFElements).forEach((elem) => {
    if (!(elem instanceof HTMLAnchorElement)) {
      return;
    }

    elem.addEventListener('click', (e) => {
      e.preventDefault(); // Cancel the native event
      e.stopPropagation(); // Don't bubble/capture the event any further

      const oldElemTextContent = elem.textContent;
      elem.disabled = true;
      elem.textContent = 'Loading...';
      const post_id = elem.hash;

      $.ajax({
        url: fs_object.ajax_url,
        type: 'POST',
        data: {
          action: 'fetch_course_pdf',
          post_id,
        },
        success: function ({ success = false, data: { url = '' } }) {
          if (!success || 0 === url.length) {
            return;
          }

          window.open(url, '_blank');

          elem.disabled = false;
          elem.textContent = oldElemTextContent;
        },
      });
    });
  });
});
